import * as THREE from 'three';
import * as CANNON from 'cannon-es';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import merge from 'lodash/merge';

/**
 * Ground
 * 
 * @param {THREE.Scene} scene 
 * @param {CANNON.World} world 
 * @param {Object} properties 
 */
export default class Ground {
    constructor(scene, world, properties) {
        this.scene = scene;
        this.world = world;
        this.gltfLoader = new GLTFLoader();
        this.properties = merge({
            position: {
                x: 0,
                y: -0.01,
                z: 0
            },
            dimension: {
                width: 50,
                height: 50
            },
            castShadow: true,
            receiveShadow: true,
            material: {
                color: 0x444444
            },
            physics: {
                materialName: 'groundMaterial',
                mass: 0,
                restitution: -1,
                friction: 0.7
            }
        }, properties); // Deep merge properties
    }

    createGeometry() {
        return new THREE.PlaneGeometry(this.properties.dimension.width, this.properties.dimension.height);
    }

    async createMaterial() {
        const gltf = await this.gltfLoader.loadAsync('macro_flour_1k/macro_flour_1k.gltf');

        const groundMesh = gltf.scene.children[0]
        
        const groundMaterial = groundMesh.material;

        return groundMaterial;
    }

    async build() {
        const groundGeometry = this.createGeometry();
        const groundMaterial = await this.createMaterial();
        const ground = new THREE.Mesh(groundGeometry, groundMaterial);

        // Rotate the ground to be horizontal and slightly lower to avoid z-fighting
        ground.rotation.x = -Math.PI / 2;
        ground.position.y = -0.01;

        ground.castShadow = this.properties.castShadow;
        ground.receiveShadow = this.properties.receiveShadow;

        // Add the ground to the scene
        this.scene.add(ground);

        // Add physics to the ground
        const groundBody = new CANNON.Body({
            mass: this.properties.physics.mass ?? 0,
            shape: new CANNON.Plane(),
        });

        // Add restitution to the ground
        groundBody.material = new CANNON.Material(this.properties.physics.materialName);
        groundBody.material.restitution = this.properties.physics.restitution;
        groundBody.material.friction = this.properties.physics.friction;
        groundBody.quaternion.setFromEuler(-Math.PI / 2, 0, 0); // Set the ground to be horizontal

        // Add the ground to the world
        this.world.addBody(groundBody);
    }

}
